import {forwardRef, ReactNode, useCallback, useRef, useState} from 'react';
import {animated, easings, useSpring} from '@react-spring/web';
import style from './style.module.scss';
import useResizeObserver, {ResizeHandler} from 'use-resize-observer';
import classNames from 'classnames';
import {isBrowserContext} from 'core/helpers';

interface IProps {
    children: ReactNode;
    isHidden?: boolean;
    className?: string;
}

export const CollapseAnimated = forwardRef<HTMLDivElement, IProps>(function CollapseAnimated(
    {children, isHidden = false, className},
    ref,
) {
    const [initialHeight, setInitialHeight] = useState<number | null>(null);
    const containerRef = useRef<HTMLDivElement>(null);

    const handleContainerResize = useCallback<ResizeHandler>(({height}) => {
        if (!containerRef.current) {
            return;
        }
        requestAnimationFrame(() => {
            setInitialHeight(height ?? 0);
        });
    }, []);

    useResizeObserver<HTMLDivElement>({
        onResize: handleContainerResize,
        ref: containerRef,
    });

    // SSR: не используем анимацию, но рендерим тот же тег
    const springStyle = useSpring({
        // eslint-disable-next-line no-nested-ternary
        maxHeight: isBrowserContext() ? (null === initialHeight ? undefined : isHidden ? 0 : initialHeight) : undefined,
        config: {duration: isBrowserContext() ? 300 : 0, easing: easings.easeInOutCubic},
    });

    return (
        <animated.div className={classNames(className, style.container)} ref={ref as any} style={springStyle}>
            <div ref={containerRef}>{children}</div>
        </animated.div>
    );
});
